import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Button from "@/components/core/Buttons/Button";
import { servicesOrchestratorValues } from "@/config/services";
import { useTagManager } from "@/hooks/useTagManager";
import { requireAuthWithDevice } from "@/lib/guards";

export const Route = createFileRoute("/$locale/$partner/recycling/success")({
	beforeLoad: requireAuthWithDevice,
	component: RecyclingSuccess,
});

function RecyclingSuccess() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { locale, partner } = useParams({ from: "/$locale/$partner" });

	useTagManager("Step ThankYou");

	return (
		<div className="mt-36 mb-32 flex items-center flex-col">
			<div className="mb-14">
				<img
					src={`${servicesOrchestratorValues.urls.cdn}/tradein-app/success/heart-icon.svg`}
					alt="info icon"
					width={186}
					height={186}
				/>
			</div>
			<h1 className="font-semibold text-3xl mb-4">{t("Success.The recycling process is complete")}</h1>
			<div className="mt-16 mx-auto">
				<Button
					label={`${t("Buttons.Back to home")}`}
					onClick={() => {
						navigate({ to: "/$locale/$partner/home", params: { locale, partner } });
					}}
				/>
			</div>
		</div>
	);
}
